import Svg, { Path, Rect } from 'react-native-svg';
import type { TLabelSymbolProps } from '../../../types/softwareLabelTypes';

export const MdSymbol = ({ width = 28, height = 28 }: TLabelSymbolProps) => (
  <Svg width={width} height={height} viewBox="14 43 172 113">
    <Rect
      x="16.617"
      y="46.44"
      width="166.67"
      height="106.78"
      fill="none"
      stroke="#000"
      strokeWidth="5"
    />
    <Path
      d="m33.148 66.5v66.703h12.701v-49.729l12.982 49.729h0.69141 11.711 0.69141l12.982-49.729v49.729h12.701v-66.703h-8.2695-4.4316-7.9707l-11.559 44.273-11.559-44.273h-7.9707-4.4316-8.2695zm77.504 0.03125-0.08398 66.693 27.922-0.08399c21.156 0 28.607-15.888 28.607-33.264 0-17.569-7.4391-33.346-28.607-33.346h-27.838zm13.875 11.844h13.793c10.488 0 14.172 10.253 14.172 21.668 0 11.289-2.1459 21.611-14.172 21.611l-13.834 0.05468 0.04101-43.334z"
      fill="#000"
      fillRule="evenodd"
    />
  </Svg>
);
